import React, { Component } from 'react'
import Scrollchor from 'react-scrollchor'

export default class Live extends Component {

    events = window.events ? window.events : []

    componentDidMount() {
        if (window.location.hash === '#tour')
            document.getElementById('tour').scrollIntoView({ behavior: 'smooth' })
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <Scrollchor
                            className="anchor live-anchor"
                            to="#tour"
                            disableHistory={true}
                        >
                            <div onClick={() => {
                                // if (window.s_gi && window.s_dtm) {
                                //     let s = s_gi('wmg,wmggbglobal,wmgprl,wmgprlgb,wmgkanomusic.com')
                                //     s_dtm.linkTrackVars='prop1,eVar4'
                                //     s_dtm.prop1 = 'Kano'
                                //     s_dtm.eVar4 = 'Kano'
                                //     s_dtm.tl(this, 'o', 'Kano:Hoodies All Summer Pre-order:Landing:Pre-order Navigation Click')
                                // }
                            }}>
                                <div className="live-anchor__text">UK Tour</div>
                                <img className="live-anchor__arrow" src="img/downarrow.png" alt="Down arrow" />
                            </div>
                        </Scrollchor>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="live" id="tour">
                        {
                            this.events.map((event, i) =>
                                <div
                                    key={i}
                                    className={'live__date event' + (event.available ? '' : ' event--sold-out')}
                                >
                                    <div className="event__date">{event.month.substring(0, 3)} <span className="event__date__date">{event.date}</span></div>
                                    <div className="event__venue">{event.venue}</div>
                                    <div className="event__location">{event.city}, {event.country}</div>
                                    {
                                        event.available
                                            ? <a
                                                className="event__link"
                                                href={event.link}
                                                target="_blank"
                                            >Tickets</a>
                                            : <a
                                                className="event__link event__link--disabled"
                                            >Sold Out!</a>
                                    }
                                </div>
                            )
                        }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// const events = [
//     {
//         day: 'Wednesday',
//         month: 'October',
//         date: '2',
//         theDate: '02/10/2019',
//         country: 'Scotland',
//         city: 'Glasgow',
//         venue: 'The Old Fruitmarket',
//         link: 'https://www.ticketmaster.co.uk/event/360056F6B6A44D84',
//         available: true
//     },
//     {
//         day: 'Friday',
//         month: 'October',
//         date: '4',
//         theDate: '04/10/2019',
//         country: 'England',
//         city: 'Manchester',
//         venue: 'The Albert Hall',
//         link: 'http://gigst.rs/kano',
//         available: false
//     },
//     {
//         day: 'Saturday',
//         month: 'October',
//         date: '5',
//         theDate: '05/10/2019',
//         country: 'England',
//         city: 'Birmingham',
//         venue: 'Town Hall',
//         link: 'http://gigst.rs/kano',
//         available: false
//     },
//     {
//         day: 'Sunday',
//         month: 'October',
//         date: '6',
//         theDate: '06/10/2019',
//         country: 'England',
//         city: 'Brighton',
//         venue: 'Brighton Dome',
//         link: 'https://tickets.brightondome.org/online/seatSelect.asp?BOset::WSmap::seatmap::performance_ids=5B4A2DF7-0C5B-4508-BB84-49CDBA000130',
//         available: false
//     },
//     {
//         day: 'Monday',
//         month: 'October',
//         date: '7',
//         theDate: '07/10/2019',
//         country: 'England',
//         city: 'London',
//         venue: 'Royal Albert Hall',
//         link: 'https://www.royalalberthall.com/tickets/events/2019/kano/',
//         available: false
//     },
//     {
//         day: 'Friday',
//         month: 'January',
//         date: '31',
//         theDate: '31/01/2020',
//         country: 'England',
//         city: 'Bournemouth',
//         venue: 'o2 Academy',
//         link: 'https://www.gigsandtours.com/event/kano/o2-academy-bournemouth-bournemouth/1423969',
//         available: false
//     },
//     {
//         day: 'Saturday',
//         month: 'February',
//         date: '01',
//         theDate: '01/02/2020',
//         country: 'Wales',
//         city: 'Cardiff',
//         venue: 'C.U. Students Union',
//         link: 'https://www.gigsandtours.com/event/kano/the-great-hall-cardiff-uni-cardiff/1423970',
//         available: true
//     },
//     {
//         day: 'Sunday',
//         month: 'February',
//         date: '02',
//         theDate: '02/02/2020',
//         country: 'England',
//         city: 'Bristol',
//         venue: 'o2 Academy',
//         link: 'https://www.gigsandtours.com/event/kano/o2-academy-bristol-bristol/1423973',
//         available: false
//     },
//     {
//         day: 'Monday',
//         month: 'February',
//         date: '03',
//         theDate: '02/03/2020',
//         country: 'England',
//         city: 'Liverpool',
//         venue: 'o2 Academy',
//         link: 'https://www.gigsandtours.com/event/kano/o2-academy-liverpool-liverpool/1424036',
//         available: true
//     },
//     {
//         day: 'Friday',
//         month: 'February',
//         date: '07',
//         theDate: '07/02/2020',
//         country: 'England',
//         city: 'London',
//         venue: 'The Drumsheds',
//         link: 'https://www.seetickets.com/event/kano/drumsheds/1425302',
//         available: true
//     },
//     {
//         day: 'Wednesday',
//         month: 'February',
//         date: '12',
//         theDate: '12/02/2020',
//         country: 'England',
//         city: 'Leeds',
//         venue: 'o2 Academy',
//         link: 'https://www.gigsandtours.com/event/kano/o2-academy-leeds-leeds/1424045',
//         available: true
//     },
//     {
//         day: 'Thursday',
//         month: 'February',
//         date: '13',
//         theDate: '13/02/2020',
//         country: 'England',
//         city: 'Nottingham',
//         venue: 'Rock City',
//         link: 'https://www.gigsandtours.com/event/kano/rock-city-nottingham/1424051',
//         available: false
//     },
//     {
//         day: 'Friday',
//         month: 'February',
//         date: '14',
//         theDate: '14/02/2020',
//         country: 'England',
//         city: 'Birmingham',
//         venue: 'o2 Academy',
//         link: 'https://www.gigsandtours.com/event/kano/o2-academy-birmingham-birmingham/1424056',
//         available: true
//     },
//     {
//         day: 'Saturday',
//         month: 'February',
//         date: '15',
//         theDate: '15/02/2020',
//         country: 'England',
//         city: 'Manchester',
//         venue: 'o2 Victoria Warehouse',
//         link: 'https://www.gigsandtours.com/event/kano/o2-victoria-warehouse-manchester/1424058',
//         available: true
//     }
// ]
